// =============================================
// SERVICIO DE GASTOS
// Maneja las peticiones al API de gastos
// =============================================

import api from './api';

const expenseService = {
  // GASTOS: Obtener todos los gastos (con filtros opcionales)
  getAll: async (filters = {}) => {
    const params = {};
    if (filters.start_date) params.start_date = filters.start_date;
    if (filters.end_date) params.end_date = filters.end_date;
    if (filters.category_id) params.category_id = filters.category_id;

    const response = await api.get('/expenses', { params });
    return response.data;
  },

  // GASTOS: Obtener gasto por ID
  getById: async (id) => {
    const response = await api.get(`/expenses/${id}`);
    return response.data;
  },

  // GASTOS: Crear nuevo gasto (con archivo)
  create: async (expenseData) => {
    const formData = new FormData();

    // GASTOS: Agregar campos al FormData
    formData.append('category_id', expenseData.category_id);
    formData.append('description', expenseData.description);
    formData.append('amount', expenseData.amount);
    formData.append('expense_date', expenseData.expense_date);
    if (expenseData.notes) {
      formData.append('notes', expenseData.notes);
    }

    // GASTOS: Agregar archivo si existe
    if (expenseData.receipt) {
      formData.append('receipt', expenseData.receipt);
    }

    const response = await api.post('/expenses', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // GASTOS: Actualizar gasto (con archivo opcional)
  update: async (id, expenseData) => {
    const formData = new FormData();

    // GASTOS: Solo agregar campos que se están actualizando
    if (expenseData.category_id !== undefined) {
      formData.append('category_id', expenseData.category_id);
    }
    if (expenseData.description !== undefined) {
      formData.append('description', expenseData.description);
    }
    if (expenseData.amount !== undefined) {
      formData.append('amount', expenseData.amount);
    }
    if (expenseData.expense_date !== undefined) {
      formData.append('expense_date', expenseData.expense_date);
    }
    if (expenseData.notes !== undefined) {
      formData.append('notes', expenseData.notes);
    }

    // GASTOS: Agregar nuevo archivo si se proporciona
    if (expenseData.receipt) {
      formData.append('receipt', expenseData.receipt);
    }

    const response = await api.put(`/expenses/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // GASTOS: Eliminar gasto
  delete: async (id) => {
    const response = await api.delete(`/expenses/${id}`);
    return response.data;
  },

  // GASTOS: Obtener estadísticas de gastos
  getStats: async (filters = {}) => {
    const params = {};
    if (filters.start_date) params.start_date = filters.start_date;
    if (filters.end_date) params.end_date = filters.end_date;

    const response = await api.get('/expenses/stats', { params });
    return response.data;
  },

  // CATEGORÍAS: Obtener todas las categorías activas
  getCategories: async () => {
    const response = await api.get('/expense-categories');
    return response.data;
  },

  // GASTOS: Obtener URL del comprobante
  getReceiptUrl: (filename) => {
    if (!filename) return null;
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
    // Remove '/api' from the end to get the base server URL
    const BASE_URL = API_URL.replace(/\/api$/, '');
    return `${BASE_URL}/uploads/expenses/${filename}`;
  },
};

export default expenseService;
